import styled, { createGlobalStyle, keyframes } from 'styled-components';
import React from 'react';
import { UiMask } from '../styled';

const aniLoading = keyframes`
  0%, 80%, 100% {
    transform: scale(0.0);
    -webkit-transform: scale(0.0);
  }
  40% {
    transform: scale(1.0);
    -webkit-transform: scale(1.0);
  }
`;

const Mask = styled(UiMask)`
  z-index: ${(props) => {
    return props.theme.zIndex.modalMask;
  }};
`;

const Wrap = styled.div<{ ref: any }>`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: ${(props) => {
    return props.theme.zIndex.modalMask;
  }};
  width: 420px;

  .inner {
    padding: 20px 0;
    box-sizing: border-box;
    border-radius: 3px;
    background-color: #fff;
    box-shadow: 0 0 5px 1px rgba(0, 0, 0, 0.4);
  }

  &._h5_modal,
  &.hideFooter {
    .inner {
      padding-bottom: 0;
    }
  }

  &._dark,
  ._dark & {
    .inner {
      //padding-top: 0;
      //background: linear-gradient(0deg, #27303a, #27303a);
      background: #3e454d;
      box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
    }
  }

  &.modal-blank {
    .inner {
      //padding: 0;
      border-radius: 0;
      background-color: transparent;
      box-shadow: unset !important;
    }
  }

  &._content_modal {
    width: auto;
    height: auto;
  }

  &._h5_modal {
    width: 384px;

    .inner {
      width: 384px;
      //padding: 20px 0 4px 0;
    }
  }

  //&.modal-iframe {
  //  .inner {
  //    padding: 0;
  //    box-shadow: none;
  //    background: transparent;
  //  }
  //}
`;

const Header = styled.div.withConfig({
  shouldForwardProp: (props) => {
    return !['moveEnable', ''].includes(props);
  },
})<{ moveEnable: boolean }>`
  padding: 0 24px;
  margin-top: -20px;
  height: 48px;
  display: flex;
  align-items: center;
  position: relative;
  box-sizing: border-box;
  border-bottom: solid 1px #ebebeb;
  cursor: ${(props) => {
    return props.moveEnable ? 'move' : 'default';
  }};

  ._h5_modal & {
    padding: 0 20px;
  }

  &.noBorder {
    border-bottom: 0;
    margin-bottom: -20px;
  }

  .modal-title {
    color: ${(props) => {
      return props.theme.color.dark;
    }};
    font-size: var(--fs-md);
    font-weight: bold;
  }

  .modal-close {
    //float: right;
    cursor: pointer;
    position: absolute;
    display: inline-block;
    color: rgba(0, 0, 0, 0.45);
    font-weight: bold;
    top: 17px;
    right: 24px;
    line-height: 1;

    .iconfont {
      font-size: var(--fs-md);
    }

    &:hover {
      color: rgba(0, 0, 0, 0.8);
    }
  }

  ._dark & {
    border-bottom: none;
    //line-height: 1;
    //padding: 18px 18px 6px;
    padding-left: 18px;
    padding-right: 18px;

    .modal-title {
      color: #fff;
      font-weight: normal;
    }

    .modal-close {
      //top: 22px;
      //right: 18px;
      color: #d7d7d7;

      &:hover {
        color: #d7d7d7;
      }
    }
  }
`;

const Body = styled.div`
  padding: 20px 24px;
  color: ${(props) => {
    return props.theme.color.gray;
  }};
  min-height: 50px;
  min-width: 360px;
  font-size: var(--fs-md);
  //text-align: center;'

  ._h5_modal &,
  .modal-iframe & {
    padding: 0 4px 4px !important;
    min-width: auto;
  }

  .check-tip {
    padding-top: 20px;
    color: ${(props) => {
      return props.theme.color.grayLight;
    }};

    .iconfont {
      margin-right: 4px;
    }

    .iconfont,
    span {
      cursor: pointer;
      display: inline-block;
      vertical-align: middle;
      line-height: 1;
    }
  }

  iframe {
    display: block;
    width: 100%;
    border-radius: 3px;
  }

  ._dark & {
    color: #fff;
    padding: 0 18px 18px;

    .check-tip {
      color: #ddd;
    }
  }
`;

const Footer = styled.div`
  box-sizing: border-box;
  padding: 10px 24px;
  text-align: right;
  border-top: solid 1px #ebebeb;
  margin-bottom: -20px;
  height: 56px;

  .btn,
  ._btn {
    min-width: 120px;
  }

  .btn + .btn,
  ._btn + ._btn {
    margin-left: 12px;
  }

  ._dark & {
    border-top: none;
  }

  ._h5_modal & {
    display: none;
  }
`;

export { Wrap, Mask, Header, Body, Footer };
